import classNames from 'classnames'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './PostCard.module.scss'

function PostCard({
  className,
  title,
  pubDate,
  timeToRead,
  image,
  path,
  tag = 'Product',
  excerpt,
  alwaysShowReadMore,
  ...rest
}) {
  return (
    <article className={classNames(styles.articleCard, className)} {...rest}>
      <Link
        to={path}
        className={styles.link}
        aria-label="Link to post detail"
      />
      {/* {tag && <div className={styles.tag}>{tag}</div>} */}

      {image && (
        <div className={styles.imgWrapp}>
          <GatsbyImage image={image} alt="Bamboo post" />
        </div>
      )}

      <div className={styles.additionaData}>
        <span className={styles.date}>{pubDate}</span>
        <span className={styles.timeToRead}>{timeToRead} min read</span>
      </div>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.excerpt}>{excerpt}</div>
      <div
        className={classNames(
          styles.readMore,
          alwaysShowReadMore && styles.showReadMore
        )}
      >
        Read more &gt;
      </div>
    </article>
  )
}

PostCard.propTypes = {
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  pubDate: PropTypes.string.isRequired,
  timeToRead: PropTypes.number.isRequired,
  image: PropTypes.object,
  className: PropTypes.string,
}

export default PostCard
